<template>
  <div id="video" :class="{ single: isSingle }">
    <div class="back z4 caps font-size-large" v-if="isSingle">
      <router-link :to="videosLink">SOE.TV</router-link></div>
    <live v-if="isVisible('Live')"></live>
    <zooming-words v-if="isVisible('zoomingWords')"></zooming-words>
    <video-player v-if="isVisible('videoPlayer')"></video-player>
  </div>
</template>

<script>
import Live from '@/components/Live'
import ZoomingWords from '@/components/ZoomingWords'
import VideoPlayer from '@/components/VideoPlayer'

export default {

  name: 'Video',

  components: {
    Live,
    ZoomingWords,
    VideoPlayer
  },

  data () {
    return {

    }
  },

  computed: {
    isSingle () {
      return this.$route.name === 'Video'
    },
    videosLink () {
      if (this.$route.hash) {
        return `/videos/${this.$route.hash}`
      } else {
        return `/videos/#${this.$route.params.slug}`
      }
    }
  },

  methods: {
    isVisible: function (name) {
      // If there is a video hash, play the video
      if (this.$route.name === 'Video' || this.$route.name === 'VideoPlay' || (this.$route.name === 'Videos' && this.$route.params.slug) || this.$route.hash) {
        return name === 'videoPlayer'
      } else {
        if (this.$route.name === 'ZoomingWords' || this.$route.hash.includes('words')) {
          return name === 'zoomingWords'
        } else {
          return name === 'Live'
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .back {
    position: fixed;
    top: 2em;
    left: 2em;

    a {
      color: var(--color-black);
      border-bottom: 1px solid var(--color-green);
      display: inline-block;
    }
  }
  #video {
    color: black;
    position: fixed;
    top: 2em;
    right: 2em;

    &.single {
      position: relative;
      top: 0;
      left: 0;
    }
  }

  @media only screen and (max-width: 1024px) {
    #video {
      top: 0;
      left: 0;
      z-index: 9999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue